import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';


import { NgForm } from '@angular/forms';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { SubjectBillingItem } from '../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../shared/models/subjectInvoiceItem.model';


import { Payment } from './../../../shared/models/payment.model';
import { InvoicePayment } from '../../../shared/models/invoicePayment.model';



// Import the MyoAPIPaymentsToolsWidget - to use the functions
// place in the providers of the page.

// tslint:disable-next-line:import-spacing
import { MyobApiInvoicePaymentSyncToolsWidgetComponent }
 from './../../../components/myob/myob-api-invoice-payment-sync-tools-widget/myob-api-invoice-payment-sync-tools-widget.component';
 import { MyobApiPurchasePaymentSyncToolsWidgetComponent }
 from './../../../components/myob/myob-api-purchase-payment-sync-tools-widget/myob-api-purchase-payment-sync-tools-widget.component';

 import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { Brand } from './../../../shared/models/brand.model';
import { Spending } from './../../../shared/models/spending.model';
import { WorkOrderPayment } from './../../../shared/models/workOrderPayment.model';
import { SubjectWorkOrder } from './../../../shared/models/subjectWorkOrder.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard

@Component({
  selector: 'app-work-order-bulk-payment-widget',
  templateUrl: './work-order-bulk-payment-widget.component.html',
  styleUrls: ['./work-order-bulk-payment-widget.component.css'],
  providers: [MyobApiPurchasePaymentSyncToolsWidgetComponent]
})
export class WorkOrderBulkPaymentWidgetComponent implements OnInit {


  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;
  @Input() to_brand_id;
  @Input() to_agent_id;

  @Input() is_create_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() is_update_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  // @Input() invoice_id?; // impliments on changes.
  // @Input() invoice_number?; // impliments on changes.

  @Input() work_order_id?; // impliments on changes.
  @Input() work_order_number?; // impliments on changes.

  // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent ;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'bulk'; // side | abstract | full / single / bulk
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel3') closeParentModel3: EventEmitter<any> = new EventEmitter(); // simple close window
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();

  @Output('refreshSujectInvoicePage') refreshSujectInvoicePage: EventEmitter<any> = new EventEmitter();
  @Output('refreshSujectWorkOrderPage') refreshSujectWorkOrderPage: EventEmitter<any> = new EventEmitter();
     // access the template form
     @ViewChild('invoicePaymentForm') invoicePaymentForm: NgForm;

     @Input() search_count?; // if > 1 there is array of work_order is that will atomatically be added to the payment array
     @Input() search_array?; // if > 1 there is array of work_order is that will atomatically be added to the payment array

  job: Object;
  billing_tasks: Object;
  model: any;
  combo_model: Brand;

  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  job_type: Object;
  job_type_name: any;
  job_type_id: any;
  job_type_location: Object;
  job_type_location_name: any;
  job_type_court: Object;
  job_type_court_name: any;
  new_subject_billing_item_id: any;
  returned_subject_billing_item_id: any;
  new_invoice_item_id: any;
  returned_invoice_item_id: any;
  
  // invoiceItemsList: any = [];
  // invoiceItemsList2: SubjectInvoiceItem;
  // invoicePaymentItemsList: any = [];
  // invoicePaymentModelList: any = [];
  // invoice_model: SubjectInvoice;

  workOrderItemsList: any = [];
  workOrderItemsList2: SubjectInvoiceItem;
  workOrderPaymentItemsList: any = [];
  workOrderPaymentModelList: any = [];
  work_order_model: SubjectWorkOrder;



  // paymentModel: Payment = new Payment(); // sets up the model correctly on create.
  // invoicePaymentModel: InvoicePayment = new InvoicePayment(); // sets up the model correctly on create.

  spendingModel: Spending = new Spending(); // sets up the model correctly on create.
  workOrderPaymentModel: WorkOrderPayment = new WorkOrderPayment(); // sets up the model correctly on create.
 

  invoice_item_model: any = SubjectInvoiceItem;
  myob_account_codes: any;
  myob_tax_codes: Object;
  invoiceItem: Object;

  invoice_total: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  // new_payment_id: any;
  new_spending_id: any;
  // returned_payment_id: any;
  returned_spending_id: any;
  // invoice_update_payment_model: any = [];
  work_order_update_payment_model: any = [];
  brands: any;
  // invoicePaymentItemsList_total_all: any;
  // invoicePaymentItemsList_remaining_total_all: any;
  // invoicePaymentItemsList_gst_total_all: any;
  // invoicePaymentItemsList_subtotal_all: any;
  // invoicePaymentItemsList_payment_total_all: any;
  workOrderPaymentItemsList_total_all: any;
  workOrderPaymentItemsList_remaining_total_all: any;
  workOrderPaymentItemsList_gst_total_all: any;
  workOrderPaymentItemsList_subtotal_all: any;
  workOrderPaymentItemsList_payment_total_all: any;

  public today = Date.now();

  // subject_invoice: SubjectInvoice;
  subject_work_order: SubjectWorkOrder;
  baseUploadURL: string;
  brands_client: any;
  brands_agent: any;

  // maps the appropriate column to fields property
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  invoice_to_brand_name: any;
  work_order_to_brand_name: any;
  @Input() process_state: string;
  @Input() process_notice: any = null;
  myobSpendingListMapped: any;
  set_RowVersion: any;
  showPrevVersion_Field: any;


     // pass selcected objects
    @Input() search_results?; 


 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute, public toastr: HotToastService,
    // vcr: ViewContainerRef, 
    private router: Router,
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public myobApi_IPTW: MyobApiInvoicePaymentSyncToolsWidgetComponent,
    public _MyobApiPurchasePaymentSyncToolsWidgetComponent: MyobApiPurchasePaymentSyncToolsWidgetComponent,
    private sanitizer: DomSanitizer,
    private clipboard: Clipboard, // ciipboard
 ) {



 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  // this.toastr.setRootViewContainerRef(vcr);

  // Combo Box Options
  this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
      this.getBrandsComboBoxClients(this.combo_model);
      this.getBrandsComboBoxAgents(this.combo_model);

  }

  // check for changes. to load data.
  ngOnChanges(changes) {


this.spendingModel = new Spending();  // starts a new empty payment model
this.workOrderPaymentModel = new WorkOrderPayment();  // starts a new empty payment model

//  this.invoicePaymentItemsList = new SubjectInvoice(); // starts a new empty payment model
//  this.invoicePaymentModelList = new InvoicePayment(); // starts a new empty payment model
    // this.getInvoice(this.invoice_id);
    // this.getMyobAccountCodes();

    this.spendingModel.spending_total = 0; // set to zero as to prevent NaN errors.
    this.workOrderPaymentItemsList_remaining_total_all = 0; // to prevent errors on load

    this.workOrderPaymentModel.subject_number = this.subject_number;
    this.workOrderPaymentModel.job_number = this.job_number;

   if (changes.invoice_id) {
     // deal with asynchronous Observable result
    // this.invoice_id = changes.invoice_id.currentValue;
    // this.getInvoice(this.invoice_id);
    // this.getMyobAccountCodes();

   }
 }


  ngOnInit() {
    this.getBrands();
    this.getMyobAccountCodes();
    this.getMyobTaxCodes();



    // Join two Arrays without duplicates.
// Join Without Dupes.
const joinWithoutDupes = (A, B) => {
  const a = new Set(A.map(x => x.item));
  const b = new Set(B.map(x => x.item));
  return [...A.filter(x => !b.has(x.item)), ...B.filter(x => !a.has(x.item))];
};

// Proof.
// tslint:disable-next-line:max-line-length
const output = joinWithoutDupes([{item: 'apple', description: 'lorem'}, {item: 'peach', description: 'impsum'}], [{item: 'apple', description: 'dolor'}, {item: 'grape', description: 'enum'}]);
console.log(output);


    this.spendingModel.spending_total = 0; // set to zero as to prevent NaN errors.
    this.workOrderPaymentItemsList_remaining_total_all = 0; // to prevent errors on load
    this.workOrderPaymentModel.subject_number = this.subject_number;
    this.workOrderPaymentModel.job_number = this.job_number;

    if (this.work_order_id >= 1 ) {
      this.getSubjectWorkOrder(this.work_order_id); // this pushees the work order to the workOrderPaymentItemsList[] ready for payment.

    }

// has to be a valid search count as well as a valid search array if work_orders
    if (this.search_count >= '1' ) {
      // Loop through the work order array.
      // console.log('Passed ', JSON.stringify(this.search_array));
      let newArr = Object(this.search_array);
      const  count_of_items = Object.keys(newArr).length;
         //  let res = data[0];
         // Run the job data queries.
         // need to do a loop of subject_billing items (.length)
         for (let i = 0; i < count_of_items; i++) {
           let res = newArr[i];
          console.log('Work Order to Add: ' + res.work_order_id);
          if(res.work_order_id != null) {
          this.getSubjectWorkOrder(res.work_order_id); // this pushees the work order to the workOrderPaymentItemsList[] ready for payment.
          }
        }
    }



  }



// pushInvoiceToPay(invoice_modell){
//   // console.log('Work Order_model' + invoice_model);
//   // console.log('Work_order_model JSON' + JSON.stringify(invoice_model));
//   this.invoicePaymentItemsList.push({
//     // JSON.stringify(invoice_model)
//     ...invoice_model, // this little bit of code maps the json objects/models together without having to do it all by hand.
//   }
//   );

//   // Caclulate the Full invoicePaymentsItemsList totals.
// this.doCalculations();
// }


pushWorkOrderToPay(work_order_model){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));
  // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
  if (!this.workOrderPaymentItemsList.some(el => el.work_order_id === work_order_model.work_order_id)) {
    this.workOrderPaymentItemsList.push({
      // JSON.stringify(invoice_model)
      ...work_order_model, // this little bit of code maps the json objects/models together without having to do it all by hand.
      work_orderUID: work_order_model.myob_id ,// NEW SYNC set this so that I have it for paymet for myob syncs
      agent_id: work_order_model.agent_id
    });
  }


  this.doCalculations();
}





// New way May mange search results from the below component.... 2025
refreshWorkOrdersToPay(search_results){
  this.toastr.warning("refreshing Work Orders to pay");
  this.search_results = search_results;
  this.workOrderPaymentItemsList = search_results;

    this.doCalculations();

}

// clear invoices
resetWorkOrdersToPay(){
  this.toastr.warning("reset work_orders to pay");
  this.search_results = []; // clear the holding model.
  this.workOrderPaymentItemsList = []; // clear invoice items on this component
    this.doCalculations();

}







// can also run from a child component.
doCalculations() {

// Errors below making payments stuff up

this.toastr.info('recalulating totals due.')

if(this.workOrderPaymentItemsList.length){

    // Caclulate the Full invoicePaymentsItemsList totals.
    this.workOrderPaymentItemsList_total_all = this.workOrderPaymentItemsList.filter((item) => item.work_order_total)
    .map((item) => +item.work_order_total)
    .reduce((sum, current) => sum + current);
this.workOrderPaymentItemsList_subtotal_all = this.workOrderPaymentItemsList.filter((item) => item.work_order_subtotal)
    .map((item) => +item.work_order_subtotal)
    .reduce((sum, current) => sum + current);
this.workOrderPaymentItemsList_remaining_total_all = this.workOrderPaymentItemsList.filter((item) => item.work_order_remaining_total)
    .map((item) => +item.work_order_remaining_total)
    .reduce((sum, current) => sum + current);

    if (this.workOrderPaymentItemsList !== '[]' ) { } // this did nothing

this.workOrderPaymentItemsList_payment_total_all = this.workOrderPaymentItemsList.filter((item) => item.work_order_payment_total)
    .map((item) => +item.work_order_payment_total)
    .reduce((sum, current) => sum + current);
this.workOrderPaymentItemsList_gst_total_all = this.workOrderPaymentItemsList.filter((item) => item.work_order_gst)
    .map((item) => +item.work_order_gst)
    .reduce((sum, current) => sum + current);
 
    this.spendingModel.from_brand_id = 94; // Owner Sharmans hard coded
    this.spendingModel.myob_bank_account_code_id = null; // not used
    this.spendingModel.created_by = this.sessionUserId;
    // this.spendingModel.created_date = this.today;
    this.spendingModel.updated_by = this.sessionUserId;
    // this.paymentModel.updated_date = this.today;
    if (this.widget_size === 'bulk') {
    this.spendingModel.is_bulk = 1; // for bulk payments only
    }

  }else{
    this.workOrderPaymentItemsList_subtotal_all = 0
    this.workOrderPaymentItemsList_remaining_total_all = 0
    this.workOrderPaymentItemsList_payment_total_all = 0
    this.workOrderPaymentItemsList_gst_total_all = 0
  }

}




// Set up INvoice defaults for SINGLE
// getSubjectInvoice(invoice_id) {
//   this._demoService.getSubjectInvoice(invoice_id).subscribe(
//      data => { this.subject_invoice = data;
//    let res = data[0];
//   // this.subject_invoices = res; // only return the first result and save back the the same variable.
//    // do a count if exists
//     // Automatically Load the invoice For Payment / Single
//     console.log('SingleI Invoice Pushed Model: ' + JSON.stringify(data));
//     }, // make the same data call for all
//      err => console.error(err),
//      () => {
//       this.pushInvoiceToPay(this.subject_invoice[0]);
//       this.doCalculations();
//      }
//    );
//  }
 getSubjectWorkOrder(work_order_id) {
  this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
     data => { this.subject_work_order = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists
    // Automatically Load the invoice For Payment / Single
    console.log('SingleI Work Order Pushed Model: ' + JSON.stringify(data));
    }, // make the same data call for all
     err => console.error(err),
     () => {
      this.pushWorkOrderToPay(this.subject_work_order[0]);
      this.doCalculations();
     }
   );
 }






 getBrandsComboBoxClients(combo_model) {
  this.combo_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_client = data;
      // this.invoice_to_brand_name = this.brands_client.name;
          // setup the brand name for single
            // tslint:disable-next-line:max-line-length
            if (this.to_brand_id >= 1){
            let toBrandArr = Object(data).filter((sb) => (sb.brand_id === this.to_brand_id)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
            console.log('toBrandArr: ' + JSON.stringify(toBrandArr));
            this.invoice_to_brand_name = toBrandArr[0].name;
            // let  count_of_items = invoicePaymentItemsList.length;
                      // for(let i=0;i < count_of_items; i++) {
            }
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getBrandsComboBoxAgents(combo_model) {
 this.combo_model.brand_type_id = 3;
this._demoService.getBrandsComboBox(combo_model).subscribe(
   data => { this.brands_agent = data;
    if (this.to_brand_id >= 1){
      let toBrandArr = Object(data).filter((sb) => (sb.brand_id === this.to_agent_id)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
      console.log('toBrandArr: ' + JSON.stringify(toBrandArr));
      this.work_order_to_brand_name = toBrandArr[0].name;
      // let  count_of_items = invoicePaymentItemsList.length;
                // for(let i=0;i < count_of_items; i++) {
      }
  },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}





// Apply Bulk Invoice Payment Wizard

public applyBulkPaymentWizard(spendingModel, workOrderPaymentItemsList) {

  // Step 1 : InsertLocalPaymentRecords (Spendings + Work Order_Payemnts)

        // loop and Create Local Versions
        // :: Loop a first. Objects
        let  count_of_items = workOrderPaymentItemsList.length;
        for (let i = 0; i < count_of_items; i++) {

            this.workOrderPaymentModelList = [{
              ...workOrderPaymentItemsList[i],
              payment_amount: workOrderPaymentItemsList[i].work_order_total,
              myob_account_code_id: workOrderPaymentItemsList[i].myob_account_code_id,
            //  payment_total: workOrderPaymentItemsList[i].work_order_total,
              remaining_total: 0,
              is_bulk: 1, // set so that repeater bulk invoice function works.
                ...spendingModel,
              payment_total: workOrderPaymentItemsList[i].work_order_total,
              spending_total: workOrderPaymentItemsList[i].work_order_total,
            }];

            console.log('i: ' + i);
            console.log('this.workOrderPaymentModelList' + JSON.stringify(this.workOrderPaymentModelList[0]));
            this.createSubjectSpendingW(this.workOrderPaymentModelList[0]); // a changed to see if works for bulk orders. (wierd allocations)

            // tslint:disable-next-line:max-line-length
            // this.createSubjectSpendingW(this.workOrderPaymentModelList[0]); // a single record of the payment list of work orders (this created wierd payment allocations for bulk.)
        } // end loop of workOrderPaymentItemsList



        
        // New functino for trigger of bulk payments - March 2024
          let bulk_log_content_model = {
            workOrderPaymentItemsList: workOrderPaymentItemsList,
            ...workOrderPaymentItemsList[0], // Send the first invoice details so that we can get or load the variables for Automations
            ...spendingModel,
            payment_BULK_snapshot : document.getElementById('payment_BULK_snapshot').innerHTML, // copy all formatting. ///innerHTML
          }
          


          this.gfunc.insertLog_createWorkOrderPaymentBulk(bulk_log_content_model);


  // Step 11:  End Function Process. // Done
  this.process_notice = '...Done! Your payment records are now sycronised with the Myob Cloud.';
  this.process_state = 'end';
  // this.toastr.success('<b>We Are Done!</b> Thank you <li class"fa fa-thumbs-o-up"></li>');
 };





    // :: Step 1 Functions

//  createSubjectPaymentW(model){
//   // :: do the magic here from the form.input model
//   this._demoService.createPayment(model).subscribe(
//    (data) => {
//      this.new_payment_id = data;
//      //  let res = data[0];
//    this.returned_payment_id = this.new_payment_id.last_insert_id;
//   //  console.log('payment id: ' + this.returned_payment_id);

//    },
//    (err) => console.error(err),
//   () => {
//     // console.log('Brand Loaded.');
//     // now insert the invoice payment record.
//     this.createSubjectInvoicePaymentW(model, this.returned_payment_id);
//   }
//     );
// }
 createSubjectSpendingW(model){
  // :: do the magic here from the form.input model
  this._demoService.createSpending(model).subscribe(
   (data) => {
     this.new_spending_id = data;
     //  let res = data[0];
   this.returned_spending_id = this.new_spending_id.last_insert_id;
   console.log('spending id: ' + this.returned_spending_id);
   // I am looksing the spending ID Here?
    // now insert the work order payment record
    // Commented out for testing above must run this below!!!!! FIXED.
    model.spending_id = this.returned_spending_id; // set in the model to run or work in functions.
    this.createSubjectWorkOrderPaymentW(model, this.returned_spending_id);
    this.process_notice = '... creating and collecting financial datas... > ';

   },
   (err) => console.error(err),
  () => { // movedup... to test


  }
    );
}


// createSubjectInvoicePaymentW(model,  payment_id) {
//  // :: do the magic here from the form.input model
//  const sent_model = model;
//  this._demoService.createSubjectInvoicePayment(model, payment_id).subscribe(
//   (data) => {
//   //  this.new_payment_id = data;
//     //  let res = data[0];
// // we now need to update the invoice record with
// let payment_status = 2;
// let invoice_status = 5;
// // partially paid - not allowed yet
// if (sent_model.remaining_total > 0) {
// payment_status = 3; // partially paid
// invoice_status = 4; // approved PDF
// }
// // if fully paid or more.
// if (sent_model.remaining_total < 0){
//  payment_status = 2; // fully paid
//  invoice_status = 5; // closed
//  }
// // Fixes invoice paymet payment items totals to the invoice value here (regarless of Wizard overallpaymet amount.)
// this.invoice_update_payment_model = {
//  invoice_id: model.invoice_id,
//  invoice_payment_total: model.invoice_total,
//  invoice_remaining_total: 0,
//  invoice_status_id: invoice_status, // closed
//  invoice_payment_status_id: payment_status, // fully paid
//  updated_by: this.sessionUserId,
// };
// },
// (err) => console.error(err),
// () => {
// // Update/Insert Payment Myob Function
// this.createMyobPaymentLocalFunctionW(this.invoice_update_payment_model, model, payment_id);
// // Update local values
// this.updateInvoiceAfterPaymentFiguresW(this.invoice_update_payment_model, model, payment_id);
// }
// );
// }
createSubjectWorkOrderPaymentW(model,  spending_id) {
  // :: do the magic here from the form.input model
  const sent_model = model;
  this._demoService.createSubjectWorkOrderPayment(model, spending_id).subscribe(
   (data) => {
   //  this.new_spending_id = data;
     //  let res = data[0];
 // we now need to update the work_order record with
 let payment_status = 2;
 let work_order_status = 5;
 // partially paid - not allowed yet
 if (sent_model.remaining_total > 0) {
  payment_status = 3; // partially paid
  payment_status = 4; // approved PDF
 }
 // if fully paid or more.
 if (sent_model.remaining_total < 0){
  payment_status = 2; // fully paid
  payment_status = 5; // closed
  }
 // Fixes work order paymet payment items totals to the work order value here (regarless of Wizard overallpaymet amount.)
 this.work_order_update_payment_model = {
  work_order_id: model.work_order_id,
  work_order_payment_total: model.work_order_total,
  work_order_remaining_total: 0,
  work_order_status_id: work_order_status, // closed
  work_order_payment_status_id: payment_status, // fully paid
  updated_by: this.gfunc.sessionUserId,
  updated_date: this.gfunc.today
 };

//  // Update/Insert Payment Myob Function
//  this.createMyobSpendingLocalFunctionW(this.work_order_update_payment_model, model, spending_id);
// //  // Update local values
//  this.updateWorkOrderAfterPaymentFiguresW(this.work_order_update_payment_model, model, spending_id);



 },
 (err) => console.error(err),
 () => {
 // Update/Insert Payment Myob Function
/// :: switch off this function for good
 /// this.createMyobSpendingLocalFunctionW(this.work_order_update_payment_model, model, spending_id);
 // Update local values
 this.updateWorkOrderAfterPaymentFiguresW(this.work_order_update_payment_model, model, spending_id);
 }
 );
 }




 createMyobSpendingLocalFunctionW(work_order_update_payment_model, model, work_order_id){
 // LIVE
 this.process_notice = '...Working with Myob, should not be long.';
 model.work_order_id = work_order_id; // local payment ID
 // Now Run the Upate Of the row versinos on the work order and items.

 // need to set the model.myob_account_code_id (from 1: to UID.) // run the account functions() so it has an array to filter
 this._MyobApiPurchasePaymentSyncToolsWidgetComponent.getMyobAccountCodes();
//  this.myobApi_IPTW.setMyobPaymentModelStep1W(model);
 this._MyobApiPurchasePaymentSyncToolsWidgetComponent.setMyobSpendingModelStep1(model);
 //


 this.process_notice = '... Myob connections and interactiviy ... > ';
 };






// updateInvoiceAfterPaymentFiguresW(invoice_update_payment_model, model, payment_id){
//     this._demoService.updateInvoiceAfterPaymentFigures(invoice_update_payment_model).subscribe(
//     (data) => {
//       // this.new_payment_id = data;
//       // let res = data[0];
//     },
//     (err) => console.error(err),
//     () => {
//       // console.log('.');
//           this.toastr.success('Payment + Invoice Record(s) Applied');
//           console.log('Payment + Invoice Payments Created and Inserted.');
//           this.process_notice = '... Payment + Invoice Payments Created within SOP ... > ';
//           }
//     );
//     };

updateWorkOrderAfterPaymentFiguresW(work_order_update_payment_model, model, payment_id){
  this._demoService.updateWorkOrderAfterPaymentFigures(work_order_update_payment_model).subscribe(
  (data) => {
    // this.new_work_order_id = data;
    // let res = data[0];
  },
  (err) => console.error(err),
  () => {
    // console.log('.');
    this.gfunc.insertLog_createWorkOrderPayment(model);

    // Tiggers muliple... we only want it to go once.
    // this.gfunc.insertLog_createWorkOrderPaymentBulk(model);

    // March 24 - New Trigger to run on Bulk Tigger to Send Payment Log as Variable....

        this.toastr.success('Payment + Supplier(s) Agent Records Applied');
        console.log('Payment + Work Order Payments Created and Inserted.');
        this.process_notice = '... Payment + Supplier Invoice Payments Created within SOP ... > ';
       
       
        // this.refreshSujectWorkOrderPage.emit(this.subject_id);

        this.gfunc.globalAccountsAgentInvoiceBulkPaymentViewSkipRoute(model.agent_id)

      
      }
  );
  };


    // Setp 2 Functions

  deleteWorkOrderToPayItem(key: number) {
    // grid
    let data = this.workOrderPaymentItemsList;
    // const index: number = data.indexOf(key); // key = work_order_id
    // if (index !== -1) {
    //     data.splice(index, 1);
    // }

  let key_order_id = key
// Fitters amd retirms tje 
    this.workOrderPaymentItemsList =  this.workOrderPaymentItemsList.filter(function (order) {
      // return true for salary greater than equals to 25000
      console.log('leaving IDs= ' + data[0]['work_order_id'] + ' != ' + key_order_id);
      return order.work_order_id != data[0]['work_order_id'];
    });



  this.doCalculations();
  
       };

  getBrands() {
    this._demoService.getBrands().subscribe(
       data => { this.brands = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }




// tslint:disable-next-line:comment-format
// :: Functino Created to run after a payment has been made throught on a Supplier INvoice / Purchse/Bill/Payment
   loopUpPurchaseRowVersions( UID, model) {
    this._demoService.getMyobPurchaseMapped(UID, model).subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobSpendingListMapped = data4;
     // Set the returned Variables Reququied for Update of a Myob Customer.
    //  console.log('UID: ' +  data4.UID);
    console.log('UID: ' +  data4.UID);
    // console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
  const sent_work_order_id = model.work_order_id;
  //  const sent_real_invoice_id = model.invoice_id;
  
  this.work_order_model = {}; // clear the invoice moddl.
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof model.Category === 'undefined' || model.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Order === 'undefined' || model.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.order.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Salesperson.UID; // can only call if actuall exist in the array!
  };
  
    this.set_RowVersion = data4.RowVersion;
  
  // :: If this is a delete function - as was writtetn
  // this.work_order_delete_payment_model = {
  //   // work_order_id: model.work_order_id,
  //   work_order_payment_total: null,
  //   work_order_remaining_total: data4.TotalAmount,
  //   work_order_status_id: 3, // approved
  //   work_order_payment_status_id: 1, // outstanding
  //   updated_by: this.sessionUserId,
  // };
  
  
  // make the function more universal? or make custom by itself?
     this.work_order_model = {
      //  ...data4,
      // ...this.myobSpendingListMapped, // Sin case I missed something.
      // ...this.subject_work_order[0], // I aded this to see if it grabs the approapriate variabels needed for the update.
      myob_array: JSON.stringify(data4),
      myob_id: data4.UID,
      UID: data4.UID,
      Number: data4.Number,
      Date: data4.Date,
      SupplierInvoiceNumber: data4.SupplierInvoiceNumber,
      // CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
      SupplierUID: data4.Supplier.UID,
      SupplierName: data4.Supplier.Name,
      SupplierDisplayID: data4.Supplier.DisplayID,
      ShipToAddress: data4.ShipToAddress,
      PromisedDate: data4.PromisedDate,
      BalanceDueAmount: data4.BalanceDueAmount,
      BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
      Status: data4.Status,
      // TermsPaymentIsDue: data4.Terms.PaymentIsDue,
      TermsDiscountDate: data4.Terms.DiscountDate,
      TermsBalanceDueDate: data4.Terms.BalanceDueDate,
      TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
      TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
      TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
      TermsDiscount: data4.Terms.Discount,
      TermsDueDate: data4.Terms.DueDate,
      TermsFinanceCharge: data4.Terms.FinanceCharge,
      IsTaxInclusive: data4.IsTaxInclusive,
      Subtotal: data4.Subtotal,
      SubtotalForeign: data4.SubtotalForeign,
      Freight: data4.Freight,
      FreightForeign: data4.FreightForeign,
      FreightTaxCodeUID: data4.FreightTaxCode.UID,
      TotalTax: data4.TotalTax,
      TotalTaxForeign: data4.TotalTaxForeign,
      TotalAmount: data4.TotalAmount,
      TotalAmountForeign: data4.TotalAmountForeign,
      CategoryUID: CategoryUID, // var
      SalespersonUID: SalespersonUID, // var
      Comment: data4.Comment,
      ShippingMethod: data4.ShippingMethod,
      JournalMemo: data4.JournalMemo,
      ReferralSource: data4.ReferralSource,
      BillDeliveryStatus: data4.BillDeliveryStatus,
      AppliedToDate: data4.AppliedToDate,
      LastPaymentDate: data4.LastPaymentDate,
      AppliedToDateForeign: data4.AppliedToDateForeign,
      CanApplySurcharge: data4.CanApplySurcharge,
      OrderUID: OrderUID, // var
      OnlinePaymentMethod: data4.OnlinePaymentMethod,
      ForeignCurrencyUID: data4.ForeignCurrency,
      CurrencyExchangeRate: data4.CurrencyExchangeRate,
      LastModified: data4.LastModified,
      URI: data4.URI,
      RowVersion: data4.RowVersion,
      // invoice_id: data4.invoice_id // needed for update quiery.
      // work_order_id: sent_work_order_id, // set manuall and test.
      // ...this.work_order_delete_payment_model // this sets the correct paymetn status of the work order after delete.
      ...model // for the update work orer model. I need the  values of the entire purchase (supplier invoice - work order record.)
     
      
            };
  
    //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    //   // this.invoiceItemsList = this.invoiceItemsList;
    //   if (this.invoiceItemsList !== {}) {
    //     // we udate each item in the loop that was just inserted.
    //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    //   };
  
    // this.toastr.info('collected new Work Order versions');
  // this.invoice_model = this.invoice_model;
  // this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
  // this.updateSubjectWorkOrderByUID(this.work_order_model);
  
  // console.log('Upadte WO AfterPaymentModel: ' + JSON.stringify(model));
  // console.log('UPDATE work_order_model: ' + JSON.stringify(this.work_order_model));
  // this.updateWorkOrderAfterPaymentFigures(model); /// THIS BROKE THE ROW VERSIion pull BUTTON!
  // this.updateSubjectWorkOrder(this.work_order_model);  /// only run this if need to update teh entire record!... just need now versions
  
  // this.updateSubjectWorkOrderByUID(this.work_order_model); // original script. // this really shoudl work?
  
  // create a lines model with all new data and upate existing invoice_items
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii) => (1 === 1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for (let i = 0; i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.workOrderItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  // console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
  this.workOrderItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };
    
    // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.workOrderItemsList !== '{}') {
    this.updateSubjectWorkOrderItem(this.workOrderItemsList, this.work_order_model.work_order_id);
    };
    } // End Lines Loop
  
  
    // just need to update the versions for this function of the work order
  
  this.toastr.info('Work Order Vrs Updated In SOP');
     // now finally update the invoice
    //  this.updateSubjectInvoice(model);
        // this.refreshGrid();
        // this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
   },
   error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Collecting Purchase Myob Details');
     console.log(error.error);
    },
    () => {
      console.log('UPDATE work_order_model: ' + JSON.stringify(this.work_order_model));
      this.updateSubjectWorkOrder(this.work_order_model);  /// only run this if need to update teh entire record!... just need now versions
    }
    );


  };






  updateSubjectWorkOrderItem(model, work_order_id){
    this._demoService.updateSubjectWorkOrderItemByDescription(model, work_order_id).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
      //  return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
  );
   }
  


   updateSubjectWorkOrder(work_order_model){
    this._demoService.updateSubjectWorkOrder(work_order_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
    this.toastr.success('Local SupplierPruchase/WO Updated');
       return true;
      },
      error => {
        console.log(error.error);
      this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
  );
   }




    // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
    getHtml(html){
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  
      // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
    // WORKS as I created my own function from this articel == pretty well convers
    transform2(value: any, args?: any): any {
      const doc = new DOMParser().parseFromString(value, 'text/html');
      return doc.documentElement.textContent;
    }
  
  
    copyToClipboard(id) {
      const content = document.getElementById(id).innerHTML; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }
    
    copyToClipboardPlainText(id) {
      const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }


    importPrevContentToHTML(id, content_sent, model) {
      if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
                // // model.id = id+'_HTML'
                // // const content = document.getElementById(id).innerText; // copy all formatting.
                // // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
                // // this.clipboard.copy(this.removeTags(content));
                // // this.clipboard.copy(content);

                // const content = content_sent; // copy all formatting.
                // // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
                

                // // this.attemptForm.controls['general_notes_HTML'].setValue(content);
                // this.jobForm.controls[id+'_HTML'].setValue(content);
                // this.model.special_instructions_HTML = content;


                // this.toastr.info("Updated Version: " + id+'_HTML')
                // // this.LoadSubjectserviceOutcomeTemplateParagraph(model)
                // // this.copyInGrid('btnTwo', id);
      }
    }
    
    // shows pre version field by id // ngif statments hard coded on each old text box
    showPrevVersion(id) {
      this.showPrevVersion_Field = id;
    
    } 

    hidePrevVersion() {
      this.showPrevVersion_Field = '';
    
    } 




  }

/*

// Sent Values in a Single Payment Process
       Form Values:
        {
  "payment_date": "2022-04-12T14:00:00.000Z",
  "payment_total": "600",
  "myob_account_code_id": "1",
  "invoice_number": "1100.1.1.1",
  "invoice_total": "400",
  "remaining_total": -200,
  "invoice_id": "28",
  "from_brand_id": "94",
  "to_brand_id": "97",
  "created_by": "66",
  "subject_id": "439",
  "subject_number": "1100.1.1.1",
  "job_id": "1100",
  "job_number": "1100.1"
}
        paymentModel:
        {
  "payment_total": "600",
  "subject_number": "1100.1.1.1",
  "job_number": "1100.1",
  "payment_date": "2022-04-12T14:00:00.000Z",
  "myob_account_code_id": "1"
}
        invoicePaymentModel
        {
  "subject_number": "1100.1.1.1",
  "job_number": "1100.1",
  "remaining_total": -200
}


*/





// Use this file to include as a bulk payment widget for any agent , with any outstanding work orders.